<div class="field-intervention-header">
    <app-title
        class="header-title"
        [title]="fieldInterventionBloc.value()!.name"
        (goToPreviousPage)="goToPreviousPage()" />

    <app-icon-button
        class="mt-1"
        [icon]="['fas', 'ellipsis-vertical']"
        [matMenuTriggerFor]="menu" />
    <mat-menu #menu="matMenu">
        @if (fieldInterventionBloc.value()!.status === FieldIntervention.StatusEnum.TO_PLAN) {
            <button
                mat-menu-item
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [matTooltip]="'noFieldInterventionUpdatePermission' | transloco"
                [matTooltipDisabled]="fieldInterventionPermissionService.canManageFieldIntervention()"
                (click)="editFieldIntervention.emit()">
                {{ 'edit' | transloco }}
            </button>
        }
        @if (fieldInterventionBloc.value()!.status === FieldIntervention.StatusEnum.ONGOING) {
            <button
                mat-menu-item
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [matTooltip]="'noFieldInterventionUpdatePermission' | transloco"
                [matTooltipDisabled]="fieldInterventionPermissionService.canManageFieldIntervention()"
                (click)="editContextLayers.emit()">
                {{ 'editContextLayers' | transloco }}
            </button>

            <button
                mat-menu-item
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [matTooltip]="'noFieldInterventionUpdatePermission' | transloco"
                [matTooltipDisabled]="fieldInterventionPermissionService.canManageFieldIntervention()"
                (click)="openFieldInterventionExtendEndDateModal()">
                {{ 'modifyDate' | transloco }}
            </button>

            <button
                mat-menu-item
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [matTooltip]="'noFieldInterventionUpdatePermission' | transloco"
                [matTooltipDisabled]="fieldInterventionPermissionService.canManageFieldIntervention()"
                (click)="openFieldInterventionConfirmClosingModal()">
                {{ 'fieldInterventionClose' | transloco }}
            </button>

            <button
                mat-menu-item
                [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
                [matTooltip]="'noFieldInterventionUpdatePermission' | transloco"
                [matTooltipDisabled]="fieldInterventionPermissionService.canManageFieldIntervention()"
                (click)="editFieldInterventionArea.emit()">
                {{ 'changeInterventionArea' | transloco }}
            </button>
        }

        <button
            mat-menu-item
            [disabled]="!fieldInterventionPermissionService.canManageFieldIntervention()"
            [matTooltip]="'noFieldInterventionUpdatePermission' | transloco"
            [matTooltipDisabled]="fieldInterventionPermissionService.canManageFieldIntervention()"
            [style.color]="'var(--error)'"
            (click)="deleteFieldIntervention.emit()">
            {{ 'delete' | transloco }}
        </button>
    </mat-menu>

    @if (fieldInterventionBloc.value()!.status === FieldIntervention.StatusEnum.DONE) {
        <div class="bg-background px-2">
            <span class="light-text">{{ 'closed' | transloco }}</span>
        </div>
    }
</div>
